import { useEffect, useState } from 'react'

/**
 * A ticking clock for elapsed-time copy. Stops the moment `active` is false so a finished job
 * does not keep re-rendering the page.
 */
export function useNow(active: boolean, intervalMs = 1_000): number {
  const [now, setNow] = useState(() => Date.now())

  useEffect(() => {
    if (!active) return
    setNow(Date.now())
    const timer = setInterval(() => setNow(Date.now()), intervalMs)
    return () => clearInterval(timer)
  }, [active, intervalMs])

  return now
}
